import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable, catchError, finalize, map, throwError } from 'rxjs';
import { AppToastService } from './toast/app-toast.service';
import { MinorService } from './minor/minor.service';
import { CustomNgxSpinnerService } from './spinner/custom-ngx-spinner.service';
import { GigyaService } from './gigya/gigya.service';
import { TutorService } from './tutor/tutor.service';

@Injectable()
export class InterceptorInterceptor implements HttpInterceptor {

  constructor(
    public toastService: AppToastService,
     public minor: MinorService,
     public loading: CustomNgxSpinnerService,
     public gigyaService: GigyaService,
     public tutorService: TutorService
    ) { }
    
  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (!request.url?.includes("getDictionaryLanguageTranslations") && !request.url?.includes("account/getAccountInfo?"))
      this.loading.loadingOn();
    return next.handle(request).pipe(
      map((event) => {
        return event;
      }),
      catchError(err => {
        console.log(err);
        if(err.url?.includes("account/getAccountInfo")){
          this.tutorService.tutorWithoutChilds.next(true);
        }else if (!err.url?.includes("getTeamListByIni?initiativeId")) {
          this.toastService.showError(err.error.message);
          if (err.url?.includes("getTutorMinors")) {
            this.gigyaService.logout();
          }
        }  

        const error = err.error || err.error.message || err.statusText;
        return throwError(() => error);
      }),
      finalize(() => {
        // Turn off the loading spinner
        this.loading.loadingOff();
      }))
  }
}
